<template>
  <div>
    <Head title="Create Stocktake" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/stocktake-references">Stocktake</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.date" type="date" :error="form.errors.date" class="pb-8 pr-6 w-full lg:w-1/2" />
          <div class="w-1/2 lg:w-1/2 pb-2 pr-6">
            <multiselect
              id="cycle"
              v-model="selectedCycle"
              placeholder="Cycles"
              :options="cycles"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.cycle_id"
              :style="form.errors.cycle_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchCycleChange"
              @input="onSelectedCycle"
            />
            <div v-if="form.errors.cycle_id" class="form-error">{{ form.errors.cycle_id }}</div>
          </div>
          <div class="w-1/2 lg:w-1/2 pb-2 pr-6">
            <multiselect
              id="Coverage"
              v-model="selectedCoverage"
              placeholder="Coverages"
              :options="stocktake_coverages"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.stocktake_coverage_id"
              :style="form.errors.stocktake_coverage_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchCoverageChange"
              @input="onSelectedCoverage"
            />
            <div v-if="form.errors.stocktake_coverage_id" class="form-error">{{ form.errors.stocktake_coverage_id }}</div>
          </div>
          <div class="w-1/2 lg:w-1/2 pb-2 pr-6">
            <multiselect
              id="Location"
              v-model="selectedLocation"
              placeholder="Locations"
              :options="locations"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.location_id"
              :style="form.errors.location_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchLocationChange"
              @input="onSelectedLocation"
            />
            <div v-if="form.errors.location_id" class="form-error">{{ form.errors.location_id }}</div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Create Count</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    statuses: Array,
    stocktake_coverages: Object,
    cycles: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        date: '',
        cycle_id: null,
        status: 1,
        location_id: null,
        stocktake_coverage_id: null,

      }),
      locations: null,
      selectedCycle: null,
      selectedCoverage: null,
      selectedLocation: null,
    }
  },
  methods: {
    store() {
      this.form.post('/stocktake-references')
    },
    onSelectedCycle(cycle, id) {
      this.form.cycle_id = cycle
      this.selectedCycle = cycle
    },
    onSearchCycleChange: throttle(function () {
    }, 200),
    onSelectedCoverage(coverage, id) {
      this.form.stocktake_coverage_id = coverage
      this.selectedCoverage = coverage
      let data = {};
      data.coverage = this.form.stocktake_coverage_id;
      this.locations = null;
      axios.post(`/stocktake-references/locations`, data).then(response => {
        this.locations = response.data
      })
    },
    onSearchCoverageChange: throttle(function (coverage, id) {
      let data = {};
      data.coverage = this.form.stocktake_coverage_id;
      this.locations = null;
      axios.post(`/stocktake-references/locations`, data).then(response => {
        this.locations = response.data
      })      
    }),
    onSelectedLocation(location, id) {
      this.form.location_id = location
      this.selectedLocation = location
    },
    onSearchLocationChange: throttle(function () {
      
    }),
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
